import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const UserTeamsState = {
  userTeams: {
    teams: [],
    currentTeam: null,
    loadingTeams: false,
    loadingSelectedTeam: false,
    selectedTeam: null,
    memberships: [],
  },
}

export const UserTeamsActions = {
  getUserTeams: async ({ commit }, user) => {
    commit('setLoadingTeams', true)

    return axiosRequest.get(`/users/${user.id}/teams`).
      then(({ data }) => commit('setUserTeams', data)).
      catch(handleError).
      finally(_ => commit('setLoadingTeams', false))
  },

  getUserTeamDetails: async ({ commit }, { user, id }) => {
    commit('setLoadingSelectedTeam', true)

    return axiosRequest.get(`/users/${user.id}/teams/${id}`).
      then(({ data }) => commit('setSelectedTeam', data)).
      catch(handleError).
      finally(_ => commit('setLoadingSelectedTeam', false))
  },

  changeCurrentTeam: async ({ commit, rootGetters }, teamId) => {
    const user = rootGetters.currentUser

    return axiosRequest.patch(`/users/${user.id}/teams/${teamId}/change_active`).
      then(({ data }) => commit('setCurrentUser', data, { root: true })).
      catch(handleError)
  },

  getUserMemberships: async ({ commit }, user) => {
    return axiosRequest.get(`/users/${user.id}/memberships`).
      then(({ data }) => commit('setUserMemberships', data)).
      catch(handleError)
  },
}

export const UserTeamsGetters = {
  userTeams: state => state.userTeams.teams || [],
  loadingTeams: state => state.userTeams.loadingTeams,
  currentTeam: state => state.userTeams.currentTeam,
  selectedTeam: state => state.userTeams.selectedTeam,
  loadingSelectedTeam: state => state.userTeams.loadingSelectedTeam,
  userMemberships: state => state.userTeams.memberships || [],
}

export const UserTeamsMutations = {
  setLoadingTeams: (state, loading) => (state.userTeams.loadingTeams = loading),
  setUserTeams: (state, teams) => (state.userTeams.teams = teams),
  setCurrentTeam: (state, team) => (state.userTeams.currentTeam = team),
  setSelectedTeam: (state, team) => (state.userTeams.selectedTeam = team),
  setLoadingSelectedTeam: (state, loading) => (state.userTeams.loadingSelectedTeam = loading),
  setUserMemberships: (state, memberships) => (state.userTeams.memberships = memberships),
}
